import { Box, Text } from 'grommet'
import { CSSProperties, ReactNode } from 'react'
import { PencilIcon, Trash } from '../../../assets/svgs'
import { isArrayOfStrings } from '../../../utils'

type Props = {
  title?: string
  data: { [x: string]: string | number | undefined | ReactNode | string[] }
  onEditClick?: () => void
  onRemoveClick?: () => void
  keyStyle?: CSSProperties
}

export default function InformationList({ data, title, onEditClick, onRemoveClick, keyStyle }: Props) {
  return (
    <Box pad={{ top: 'medium' }}>
      {title && (
        <Box background="#F7F7F7" direction="row" justify="between" pad={{ horizontal: '10px', vertical: '4px' }}>
          <Text color="#050505" size="small" weight={500}>
            {title}
          </Text>
          <Box direction="row" gap={'16px'}>
            {onEditClick && (
              <Box direction="row" gap="xsmall" onClick={onEditClick}>
                <PencilIcon />
              </Box>
            )}
            {onRemoveClick && (
              <Box direction="row" gap="xsmall" onClick={onRemoveClick}>
                <Trash />
              </Box>
            )}
          </Box>
        </Box>
      )}
      <Box className="staff-container" pad={{ horizontal: 'medium', vertical: 'small' }}>
        {Object.entries(data)?.map(([key, value], index) => (
          <Box direction="row" justify="between" key={`${index}-${value}`} pad={{ vertical: 'small' }}>
            <Text color={'#666666'} size="small" style={{ textTransform: 'capitalize', ...keyStyle }}>
              {key}
            </Text>

            {typeof value === 'string' || typeof value === 'number' || typeof value === 'undefined' ? (
              <Text
                color={'#000'}
                size="small"
                style={{ maxWidth: '340px', textAlign: 'right', textTransform: 'capitalize' }}
              >
                {typeof value === 'string' ? value.replace(/_/g, ' ') : value}
              </Text>
            ) : isArrayOfStrings(value) ? (
              <Box>
                {value?.map(item => (
                  <Text
                    color={'#000'}
                    key={item}
                    size="small"
                    style={{ maxWidth: '340px', textAlign: 'right', textTransform: 'capitalize' }}
                  >
                    {item.replace(/_/g, ' ')}
                  </Text>
                ))}
              </Box>
            ) : (
              <Box>{value}</Box>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  )
}
